import type { TMessages } from '@/types/TMessages'

export const messages = {
  title: 'Ничего не нашлось',
  subTitle: 'Переформулируйте запрос или поищите что-нибудь ещё',
} satisfies TMessages
